module.exports = __webpack_public_path__ + "static/img/YK.d349c33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/YK.png
// module id = NShh
// module chunks = 18